import { Link } from "react-router-dom";
import { genres } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-heading text-lg text-foreground-950">歪歪漫画</span>
            </div>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              高清漫画在线阅读平台，汇集热血、校园、恋爱、科幻、悬疑等丰富类型的优质漫画作品。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900">快速导航</h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/" className="text-foreground-600 hover:text-primary-600">首页</Link></li>
              <li><Link to="/category/全部" className="text-foreground-600 hover:text-primary-600">全部分类</Link></li>
              <li><Link to="/search" className="text-foreground-600 hover:text-primary-600">搜索漫画</Link></li>
              <li><Link to="/about" className="text-foreground-600 hover:text-primary-600">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900">热门分类</h4>
            <ul className="mt-3 grid grid-cols-2 gap-2 text-sm">
              {genres.slice(0, 6).map((g) => (
                <li key={g}>
                  <Link to={`/category/${encodeURIComponent(g)}`} className="text-foreground-600 hover:text-primary-600">
                    {g}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900">联系我们</h4>
            <ul className="mt-3 space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-foreground-500"></i>
                support@waiwaimanhua.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-foreground-500"></i>
                每日 09:00 - 22:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-foreground-500"></i>
                在线服务平台
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-secondary-200 pt-6">
          <p className="text-xs text-foreground-500 leading-relaxed">
            免责声明：本站所有漫画作品、封面及章节图片均为虚构演示内容，仅用于产品功能展示，不涉及任何真实作品、人物、评分或奖项。站内数据与交互均为前端演示，不代表真实版权内容。
          </p>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-foreground-500">© 2026 歪歪漫画在线观看. 保留所有权利。</p>
            <p className="text-xs text-foreground-500">仅为前端演示，待接入真实服务</p>
          </div>
        </div>
      </div>
    </footer>
  );
}